<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-nav-item",
    {
      on: {
        click: function ($event) {
          _vm.skin = _vm.isDark ? "light" : "dark"
        },
      },
    },
    [
      _c("feather-icon", {
        directives: [
          {
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.v-primary",
            modifiers: { hover: true, "v-primary": true },
          },
        ],
        attrs: {
          size: "21",
          title: _vm.$t("Mode.SwitchToMode", {
            mode: _vm.isDark ? _vm.$t("Mode.Light") : _vm.$t("Mode.Dark"),
          }),
          icon: (_vm.isDark ? "Sun" : "Moon") + "Icon",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/@core/layouts/components/app-navbar/components/DarkToggler.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import core_app_config_useAppConfig from '@core/app-config/useAppConfig';
import * as vue_composition_api from '@vue/composition-api';
import * as bootstrapvue from 'bootstrap-vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




export default ({
  render,
  staticRenderFns,
  components: {
    BNavItem: bootstrapvue["BNavItem"]
  },
  directives: {
    "b-tooltip": bootstrapvue["VBTooltip"]
  },
  setup() {
    const {
      skin
    } = core_app_config_useAppConfig();
    const isDark = vue_composition_api.computed(() => skin.value === "dark");
    return {
      skin,
      isDark
    };
  }
});

//# sourceURL=webpack:///./src/@core/layouts/components/app-navbar/components/DarkToggler.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

